import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import { RootState } from '../../state-management/rootReducer';

const initialState: ToasterState = {
  id: '',
  message: '',
  isError: false,
};

export const toasterSlice = createSlice({
  name: 'toasts',
  initialState: [initialState],
  reducers: {
    addToast: (
      state: ToasterState[] = [],
      action: PayloadAction<ToasterState>
    ) => {
      action.payload.id = uuidv4();
      return [action.payload, ...state];
    },
    removeToast: (
      state: ToasterState[] = [],
      action: PayloadAction<string>
    ) => {
      return state.filter((toast) => toast.id !== action.payload);
    },
  },
});

export const { addToast, removeToast } = toasterSlice.actions;

export const getToasts = (state: RootState) => state.toasts;

export default toasterSlice.reducer;
